<header>Sign Up</header>
<div class="header-text">We'll never share your email with anyone else.</div>

<form [formGroup]="signupForm" (ngSubmit)="onSubmit()">
  <div class="email">
    <mat-form-field appearance="outline">
      <mat-label>Email address</mat-label>
      <input matInput id="email" type="email" formControlName="email" />
      <mat-error *ngIf="email?.errors">Please enter a valid email address.</mat-error>
    </mat-form-field>
  </div>

  <div class="password">
    <mat-form-field appearance="outline">
      <mat-label>Password</mat-label>
      <input matInput id="password" type="passsword" formControlName="password" />
      <mat-error *ngIf="password?.errors!['required']">Please enter your password.</mat-error>
      <mat-error *ngIf="password?.errors!['minlength']">Password must be at least {{password.errors!['minlength']['requiredLength']}} characters long.</mat-error>
    </mat-form-field>
  </div>

  <button mat-flat-button color="primary" type="submit" [disabled]="!signupForm.valid">Sign Up</button>
</form>

<button class="google-login" (click)="authService.googleLogin()">
  <img class="button-icon" src="assets/imgs/GoogleIcon.webp" alt="Google Logo" /><span>Login with Google</span>
</button>

<button mat-stroked-button color="primary" class="email-login"
        [routerLink]="nav_path.signIn">Login with Email & Password</button>
